<template>
  <div class="home_wrapper">
    <prismic-image :field="home_background" class="home_background"/>
    <prismic-image :field="home_background_mobile" class="home_background_mobile"/>
    <prismic-image :field="home_top_image" class="header_top_image"/>    
    <prismic-image :field="home_top_image_mobile" class="header_top_image_mobile"/>        

    <div class="home_top">
      <h1 class="home_title">{{ $prismic.richTextAsPlain(home_title) }}</h1>
      <div class="home_description">{{ $prismic.richTextAsPlain(home_description) }}</div>
      <a class="header_button_link" href="mailto:info@showconcept.co">
        <div class="black_button header_button">
          <span>{{ $prismic.richTextAsPlain(header_button) }}</span>
        </div>
      </a>
    </div>
    <!-- end home top -->
    <div class="home_middle">
      <div class="home_middle_title">{{ $prismic.richTextAsPlain(home_middle_title) }}</div>
      <div class="home_middle_description">{{ $prismic.richTextAsPlain(home_middle_description) }}</div>
      <div class="home_middle_company_name">{{ $prismic.richTextAsPlain(home_middle_company_name) }}</div>
      <div class="boxes">
        <div class="box">
          <prismic-image :field="box_image" class="box_image"/>
          <prismic-image :field="box1_icon" class="box_icon"/>
          <div class="box_title">{{ $prismic.richTextAsPlain(box1_title) }}</div>
          <div class="box_description_wrapper">
            <div
              class="box_description"
            >{{ $prismic.richTextAsPlain(box1_description) | truncate(115, '...') }}</div>
          </div>
          <div class="home_middle_button_wrapper">
            <router-link :to="{ path:'page/organizacija'}">
              <div class="black_button home_middle_button">
                <span>{{ $prismic.richTextAsPlain(home_middle_button) }}</span>
              </div>
            </router-link>
          </div>
        </div>
        <!-- end box -->
        <div class="box">
          <prismic-image :field="box_image" class="box_image"/>
          <prismic-image :field="box2_icon" class="box_icon"/>
          <div class="box_title">{{ $prismic.richTextAsPlain(box2_title) }}</div>
          <div class="box_description_wrapper">
            <div
              class="box_description"
            >{{ $prismic.richTextAsPlain(box2_description) | truncate(115, '...') }}</div>
          </div>
          <div class="home_middle_button_wrapper">
            <router-link :to="{ path:'page/rental'}">
              <div class="black_button home_middle_button">
                <span>{{ $prismic.richTextAsPlain(home_middle_button) }}</span>
              </div>
            </router-link>
          </div>
        </div>
        <!-- end box -->
        <div class="box">
          <prismic-image :field="box_image" class="box_image"/>
          <prismic-image :field="box3_icon" class="box_icon"/>
          <div class="box_title">{{ $prismic.richTextAsPlain(box3_title) }}</div>
          <div class="box_description_wrapper">
            <div
              class="box_description"
            >{{ $prismic.richTextAsPlain(box3_description) | truncate(115, '...') }}</div>
          </div>
          <div class="home_middle_button_wrapper">
            <router-link :to="{ path:'page/street-food'}">
              <div class="black_button home_middle_button">
                <span>{{ $prismic.richTextAsPlain(home_middle_button) }}</span>
              </div>
            </router-link>
          </div>
        </div>
        <!-- end box -->
      </div>
      <!-- end boxes -->
    </div>
    <!-- end home middle -->
    <div class="home_events">
      <div class="events_slider_yellow">
        <div class="events_slider_title">{{ $prismic.richTextAsPlain(events_slider_title) }}</div>
        <div class="events_slider_description">{{ $prismic.richTextAsPlain(events_slider_description) }}</div>
      </div>

      <!-- query posts -->
      <div class="events_slider">
        <div v-for="(post, key) in posts" :key="key">
          <router-link :to="{ path:'/eventi/' +post.uid }">
          <div class="events_slider_inner">
            <prismic-image :field="post.data.thumbnail" class="home_thumbnail"/>
            <div class="events_slider_text">
              <div class="events_slider_text_title">
                <h3>{{ $prismic.richTextAsPlain(post.data.event_title) | truncate(43, '...')}}</h3>
              </div>
              <div
                class="events_slider_text_description"
              >{{ $prismic.richTextAsPlain(post.data.event_description) | truncate(142, '...')}}</div>
            </div><!-- events slider text -->
          </div><!-- events slider inner -->
          </router-link>
        </div><!-- end query posts -->
      </div><!-- end events slider -->
      
      <div class="arrows">
          <div class="arrow prev"><img src="arrowsvg.svg"></div>
          <div class="arrow next"><img src="arrowsvg.svg"></div>
      </div>
      <router-link :to="{ path:'/eventi' }">
        <div class="events_slider_archive_link_label">{{ $prismic.richTextAsPlain(events_slider_archive_link_label) }}</div>
      </router-link>
    </div>
    <!-- end home events   -->

    <!-- shc u brojevima -->
    <div class="shc_brojevi_wrapper">
      <div class="home_bottom_title shc_brojevi_main_title">
        <h2>{{ $prismic.richTextAsPlain(numbers_main_title) }}</h2>
      </div>
      <div class="shc_brojevi_items">
        <div class="shc_brojevi_item">
          <div class="shc_brojevi_title">{{ $prismic.richTextAsPlain(numbers_title_1) }}</div>
          <div class="shc_brojevi_subtitle">{{ $prismic.richTextAsPlain(numbers_subtitle_1) }}</div>
        </div>
        <div class="shc_brojevi_item">
          <div class="shc_brojevi_title">{{ $prismic.richTextAsPlain(numbers_title_2) }}</div>
          <div class="shc_brojevi_subtitle">{{ $prismic.richTextAsPlain(numbers_subtitle_2) }}</div>          
        </div>
        <div class="shc_brojevi_item">
          <div class="shc_brojevi_title">{{ $prismic.richTextAsPlain(numbers_title_3) }}</div>
          <div class="shc_brojevi_subtitle">{{ $prismic.richTextAsPlain(numbers_subtitle_3) }}</div>         
        </div>
        <div class="shc_brojevi_item">
          <div class="shc_brojevi_title">{{ $prismic.richTextAsPlain(numbers_title_4) }}</div>
          <div class="shc_brojevi_subtitle">{{ $prismic.richTextAsPlain(numbers_subtitle_4) }}</div>          
        </div>
      </div>
      
    </div>
    <!-- end shc u brojevima -->

    <!-- home bottom -->
    <div class="home_bottom">
      <div class="home_bottom_title">
        <h2>{{ $prismic.richTextAsPlain(partneri_title) }}</h2>
        <p>{{ $prismic.richTextAsPlain(partneri_subtitle) }}</p>
      </div>

      <div class="partneri_images">
        <div class="partner_image"><prismic-image :field="partner_image_1" /></div>
        <div class="partner_image"><prismic-image :field="partner_image_2" /></div>
        <div class="partner_image"><prismic-image :field="partner_image_3" /></div>
        <div class="partner_image"><prismic-image :field="partner_image_4" /></div>
      </div>      

    </div><!-- end home bottom -->

  </div><!-- end home wrapper -->
</template>

<script>

import $ from 'jquery'
import 'slick-carousel'

export default {
  name: 'HomePage',
  data () {
    return {
      //header
      home_title: null,
      home_description: null,
      home_background: null,
      home_background_mobile:null,
      home_top_image:null,
      home_top_image_mobile:null,
      header_button:null,
      //middle
      home_middle_title:null,
      home_middle_description:null,
      home_middle_company_name:null,
      box_image:null,
      box1_title:null,
      box1_description:null,
      box1_icon:null,
      box2_title:null,
      box2_description:null,
      box2_icon:null,
      box3_title:null,
      box3_description:null,
      box3_icon:null,
      home_middle_button:null,
      //events
      events_slider_title:null,
      events_slider_description:null,
      events_slider_archive_link_label:null,
      //slider
      posts: [],
      //numbers
      numbers_main_title:null,
      numbers_title_1:null,
      numbers_subtitle_1:null,
      numbers_title_2:null,
      numbers_subtitle_2:null,
      numbers_title_3:null,
      numbers_subtitle_3:null,
      numbers_title_4:null,
      numbers_subtitle_4:null,
      //bottom
      partneri_title:null,
      partneri_subtitle:null,
      partner_image_1:null,
      partner_image_2:null,
      partner_image_3:null,
      partner_image_4:null
    }
  },
  methods: {

    getContent () {
      //homepage general data
      this.$prismic.client.getSingle('homepage')
        .then((document) => {
          if (document) {
            //header
            this.home_title = document.data.home_title
            this.home_description = document.data.home_description
            this.home_background = document.data.home_background
            this.home_background_mobile = document.data.home_background_mobile
            this.home_top_image = document.data.home_top_image
            this.home_top_image_mobile = document.data.home_top_image_mobile
            this.header_button = document.data.header_button
            //middle
            this.home_middle_title = document.data.home_middle_title
            this.home_middle_description = document.data.home_middle_description
            this.home_middle_company_name = document.data.home_middle_company_name
            this.box_image = document.data.box_image
            this.box1_title = document.data.box1_title
            this.box1_description = document.data.box1_description
            this.box1_icon = document.data.box1_icon
            this.box2_title = document.data.box2_title
            this.box2_description = document.data.box2_description
            this.box2_icon = document.data.box2_icon
            this.box3_title = document.data.box3_title
            this.box3_description = document.data.box3_description
            this.box3_icon = document.data.box3_icon
            this.home_middle_button = document.data.home_middle_button
            //events
            this.events_slider_title = document.data.events_slider_title
            this.events_slider_description = document.data.events_slider_description
            this.events_slider_archive_link_label = document.data.events_slider_archive_link_label
            //numbers
            this.numbers_main_title = document.data.numbers_main_title
            this.numbers_title_1 = document.data.numbers_title_1
            this.numbers_subtitle_1 = document.data.numbers_subtitle_1
            this.numbers_title_2 = document.data.numbers_title_2
            this.numbers_subtitle_2 = document.data.numbers_subtitle_2
            this.numbers_title_3 = document.data.numbers_title_3
            this.numbers_subtitle_3 = document.data.numbers_subtitle_3
            this.numbers_title_4 = document.data.numbers_title_4
            this.numbers_subtitle_4 = document.data.numbers_subtitle_4
            //bottom
            this.partneri_title = document.data.partneri_title
            this.partneri_subtitle = document.data.partneri_subtitle
            this.partner_image_1 = document.data.partner_image_1
            this.partner_image_2 = document.data.partner_image_2
            this.partner_image_3 = document.data.partner_image_3
            this.partner_image_4 = document.data.partner_image_4

            //loader
            $('.loader_wrapper').fadeOut('slow').promise().done(function(){ 
              $('.home_wrapper').fadeIn('slow');
            });

          } else {
            this.$router.push({ name: 'not-found' })
          }
        })
        //events slider
        this.$prismic.client.query(
          this.$prismic.Predicates.at('document.type', 'events'),
          { pageSize : 4  },
          
          ).then((response) => {
            const posts = response.results;
            this.posts = posts;

            if(response.results_per_page == 4) {
              setTimeout(function(){ 
                $('.events_slider').slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                centerMode: true,
                variableWidth: true,
                //arrows: false,
                prevArrow: $('.prev'),
                nextArrow: $('.next'),

              });
              }, 1000);

            }           
        });
    }

    
  },
  updated(){

  },
  mounted () {
    this.getContent();
    $(document).scrollTop(0);
    $('.home_wrapper').hide(); 
  },
  beforeCreate: function() {
    document.body.className = 'homepage';
    $('.loader_wrapper').css('display','flex');
  }
}
</script>